import * as moment from 'moment';

export * from './add-ons-text';

import { IAddOnProduction, IPerformance, IFacility, IPriceType, IZoneSummary, IPrice, IPerformancePricing } from '../custom/classes/production';


export interface IAddOnsState {
    processing: boolean;
    addOnProductions: Array<IAddOnProduction>;
    priceTypeQuantity: Map<number, number>;
    reserveRequests: IReserveRequest[];
    failedReserve: Array<number>,
    totalNumberOfTicket: number;
    apiError: any;
    unseated: boolean;
}

export const defaultAddOnsModel: IAddOnsState = {
    processing: false,
    addOnProductions: [],
    reserveRequests: [],
    priceTypeQuantity: new Map<number, number>(),
    apiError: null,
    failedReserve: [],
    unseated: false,
    totalNumberOfTicket: 0
};

export interface IReserveRequest {
    performanceId: number;
    priceTypeQuantity: Map<number, number>;
    priceType: number;
    quantity: number;
    zoneId: number;
    total: number;
}


export interface IBaseAddOnProduction {

    id: string;
    productionSeasonId: number;
    /// <summary>
    /// The title of the add on
    /// </summary>
    title: string;

    synopsis: string;
    /// <summary>
    /// The url of the thumbnail image to display on the add on card
    /// </summary>
    imageUrl: string;

    /// <summary>
    /// The date of the first performance for this production
    /// </summary>
    startDate: Date;

    /// <summary>
    /// The date of the last performance for this production
    /// </summary>
    endDate: Date;

    dateRangeString: string;

    additionalInformation: string;
    /// <summary>
    /// If this production is seated or not
    /// </summary>
    seated: boolean;

    /// <summary>
    /// A dictionary of performance dates with the performanceId as the key
    /// </summary>
    performances: IPerformanceInfo[];

    togglePanel: boolean;

    loadedFromApi: boolean;

    productionDetailPageUrl: string;
}

export interface IBasePerformanceDetails {
    performanceId: number;
    productionId: number;
    pricing: IPerformancePricing;
}


export interface IPerformanceInfo {
    id: number;
    performanceDate: Date;
    performancePricing: IPerformancePricing;
    unavailable: boolean;
}

export interface IBasePerformancePricing {
    zonesAvailable: boolean;
    prices: IBasePriceType;
    zoneMapId: number;
    zones: IBaseZone[];
    priceTypeDetails: Array<IPriceType>;
}


export interface IBaseZone {
    zone: IZoneSummary;
    sectionSummaries: Array<any>;
    performanceId: number;
    availableCount: number;
    prices: Array<IPrice>;
    priceTypeDetails: Array<IPriceType>;
}

export interface IBasePrice {
    performanceId: number;
    packageId: number;
    zoneId: number;
    priceTypeId: number;
    price: number;
    enabled: boolean;
    isBase: boolean;
    parentPackageId: number;
    performancePriceTypeId: number;
    minPrice: number;
    isBest: boolean;
    offer: boolean;
    modeOfSaleOfferId: number;
}

export interface IBaseZoneSummary {
    id: number;

    description: string;

    shortDescription: string;

    rank: string;

    zoneMapId: number;

    zoneTime: string;

    abbreviation: string;

    zoneLegend: string;
}
export interface IBasePerformance {
    onSale: boolean;
    //date: Date;
    dayOfWeekString: string;
    timeSlotString: string;
    performanceDateString: string;
    performanceTimeString: string;
    performanceDateDayString: string;
    productionDetailPageLink: string;
    performanceId: number;
    productionSeasonId: number;
    title: string;

    appFacility: IFacility;
    description: string;

    shortName: string;

    ticketText1: string;

    ticketText2: string;

    ticketText3: string;

    ticketText4: string;
}

export interface IBaseFacility {
    facilityDescription: string;
    facilityId: number;
    // need venue config to be created
    facilityImageUrl: string;
}

export interface IBasePriceType {
    priceTypeId: number;
    description: string;
    shortDescription: string;
    defaultIndicator: boolean;
    isBest: string;
    offer: boolean;
    maxSeats: number;
}

export interface IDateRange {
    start: Date;
    end: Date;
}

